import { cn } from "@/lib/utils";

const STAR_PATH =
  "M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.77l-5.2 2.73.99-5.79-4.21-4.1 5.82-.85L10 1.5z";

// Google-review-style rating: five solid gold stars (#fbbc04) on a plain
// background. Mirrors TrustStars' size/className API so it drops into the same
// layouts.
export function GoogleStars({
  size = 20,
  className,
  starClassName,
}: {
  size?: number;
  className?: string;
  starClassName?: string;
}) {
  const responsive = Boolean(starClassName);
  return (
    <div
      className={cn("inline-flex items-center gap-0.5", className)}
      role="img"
      aria-label="5 van 5 sterren"
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <svg
          key={i}
          width={responsive ? undefined : size}
          height={responsive ? undefined : size}
          viewBox="0 0.1 20 20"
          fill="#fbbc04"
          className={cn("block", starClassName)}
        >
          <path d={STAR_PATH} />
        </svg>
      ))}
    </div>
  );
}
